import usePortManager from '../hooks/use-port-manager'
import useSettingsManager from '../hooks/use-settings-manager'
import PortImage from '../port-image/PortImage'
import { DrawingModal } from './DrawingModal'
import React from 'react'
import ShareModal from './ShareModal'
import ImageLayer from '../port-image/ImageLayer'

export function FinalStepLeft ({ showModal = true } = {}) {
  const port_manager = usePortManager()
  const settings_manager = useSettingsManager()
  const drawing_beslag_title = settings_manager.getOtherSettings(
    'drawing_beslag_title',
    'Bestil beslag tegning'
  )
  const drawing_beslag_description = settings_manager.getOtherSettings(
    'drawing_beslag_description',
    'Vi kontrol måler altid din port inden opsætning'
  )
  const drawing_port_title = settings_manager.getOtherSettings(
    'drawing_port_title',
    'Bestil port tegning'
  )
  const drawing_port_description = settings_manager.getOtherSettings(
    'drawing_port_description',
    'Vi kontrol måler altid din port inden opsætning'
  )
  let product_image_description = settings_manager.getOtherSettings(
    'product_image_description',
    'Pay for your new iPhone over 24 months at 0% APR with Apple ' +
    'Card. Just select Apple Card Monthly Installments and continue ' +
    'to apply.'
  )
  return <React.Fragment>
    <div className={'product-image-box grey-box'}>
      <div>
        <div className={'port-image-wrap sidebar'}>
          <PortImage/>
          <ImageLayer name={'rails_type'} className={'port-image__base'} />
        </div>
      </div>
      <div className={'product-image-box__text'}>
        {port_manager.currentPort.name}
      </div>
    </div>
    <div className={'product-image-description'}>
      <p>{product_image_description}</p>
    </div>

    {showModal ? (
      <>
        <DrawingModal
          drawingTitle={drawing_beslag_title}
          drawingDescription={drawing_beslag_description}
          drawingType="beslag"
        />
        <DrawingModal
          drawingTitle={drawing_port_title}
          drawingDescription={drawing_port_description}
          drawingType="port"
        />
        <ShareModal/>
      </>
    ) : null}
  </React.Fragment>
}